import { accAdd,accSub,accMul,accDiv} from "@/util/myUtils"
export default {
    methods:{
        _add() {//加
            let arg =Array.from(arguments)
            return arg.reduce((total,num)=>accAdd(total,num));
        },
        _subtract() {//减
            let arg =Array.from(arguments)
            return arg.reduce((total,num)=>accSub(total,num));
        },
        _multiply() {//乘
            let arg =Array.from(arguments)
            return arg.reduce((total,num)=>accMul(total,num));
        },
        _divide() {//除
            let arg =Array.from(arguments)
            return arg.reduce((total,num)=>accDiv(total,num));
        },
        zeros(length){
            let num = '';
            for (var i=0; i<length; i++) {
                num += '0'
            }
            return num;
        },
        /**
         * 小数点按位数截取
         * @param {*} number 要截取的值
         * @param {*} numLength  小数点位数
         * @param {*} isZero 是否补零
         * @returns 
         */
        fixNumber(number = 0,numLength = 2,isZero=true) {
            let length = number.toString()
            let num = '0.'
            if (length.indexOf('.') == -1) {
                return isZero?number +'.'+this.zeros(numLength):number;
            }
            length = length.split('.')[1].length < numLength ? numLength : length.split('.')[1].length
            for (var i=0; i<length; i++) {
                num += '0'
            }
            num += '1'
            let _value = Math.floor((Number(number) + Number(num)) * Math.pow(10,numLength)) / Math.pow(10,numLength);
            if(!number) return _value;
            let _float = _value.toString().split('.')[1];
            if(_float.length<numLength){
                return _value + this.zeros(numLength-_float.length)
            }
            return _value;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/cloud-clinic/mixins/calculate.js